import React, { PureComponent, ReactNode } from 'react';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
} from '@material-ui/core';
import { MyPATTextArea, MyPATExpansionPanel, MyPATMathField } from '../../../common';
import AddFeedback from '../../../content-request/components/AddFeedback';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import AddFeedbackPopup from './AddFeedbackPopup';
import { SECTIONS } from '../../helper/contentValidation';


const styles = (theme: Theme) => createStyles({
  blueColor: {
    color: '#1D7DEA'
  },
  feedbackContainer: {
    position: 'relative',
    '& .feedbackBlock': {
      top: -16,
      left: "100%",
      position: "absolute",
      marginLeft: 20,
      zIndex: 2
    }
    },
    feedbackHighlight:{
      cursor: 'pointer',
      '&:hover':{
        color: '#1d7dea',
      }
    },
  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },
  cardHeading: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  requiredHeading: {
    color: theme.palette.secondary.main,
  },
  hintBox: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing.unit,
    '& textarea': {
      border: 0,
      padding: 0,
    },
    '& h6': {
      color: theme.palette.grey[400],
    },
    '& .suggested-box': {
      background: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      width: '100%',
      marginBottom: theme.spacing.unit,
      '&:last-child': {
        marginBottom: 0,
      }
    }
  },
  optionalText: {
    fontSize: '20px',
    color: '#999999',
  }
});

interface HintsProps extends WithStyles<typeof styles> {
  isRequired: boolean,
  defaultExpanded: boolean,
  customHeading: ReactNode,
  handleFormChange: Function,
  formData: string,
  inputId: string,
  tag: string,
  openFeedback: boolean,
  addFeedback: Function,
  replyFeedback: Function,
  closeFeedback: Function,
  resolveFeedback: Function,
  clickedfeedbackData: any,
  addNewFeedback: Function,
  questionIndex?: number,
  selectedIndex: number,
  questionId?: string;
  sectionId?: string;
  authorType?: string;
  placeholder: string;
  isDisable: boolean;
  isOptional: boolean;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
}

interface HintState {
  mathEditor: any,
}

class Hints extends PureComponent<HintsProps,HintState> {

  constructor(props: HintsProps) {
    super(props);
    this.state = {
      mathEditor:null,
    }
  }

  setMathInstance = (mathEditor:any) => {
    this.setState({ mathEditor })
  }
  checkForFeedback() {
    let { clickedfeedbackData, questionId } = this.props;
    if(this.props.selectedIndex !== undefined) {
      return (( _.isEmpty(clickedfeedbackData) && this.props.openFeedback && this.props.tag === "hints" && this.props.selectedIndex === this.props.questionIndex) || (!_.isEmpty(clickedfeedbackData) && this.props.openFeedback && clickedfeedbackData.tag === "hints" && questionId === clickedfeedbackData.contentId))
    } else {
      return this.props.openFeedback && this.props.tag === "hints"

    }
  }
  render() {
    const { classes, placeholder, isRequired, defaultExpanded, customHeading, formData: questionHints, handleFormChange, inputId, questionIndex, sectionId="questionHints", isDisable, isOptional, activeValidationFeedbackSection, activeValidationFeedbackData, handleAddCommentInFeedback, createNewValidationFeedback } = this.props;
    return (
      <MyPATExpansionPanel
        isDisable={isDisable}
        hasExpandIcon
        defaultExpanded={false}
        sectionId={sectionId} // used for scrolling to this section
        variant="white"
        customCollapseTitle={
          !_.isEmpty(customHeading) ? customHeading : (
            <Typography  onClick={(event) => {
              event.stopPropagation();
              this.props.addFeedback('hints', questionIndex)}} variant="h6" className={classes.cardHeading}>
              
              <span 
            id={this.checkForFeedback() ? 'feedbackScroll' : ''}
            className={`${classes.feedbackContainer} ${this.checkForFeedback() ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}>
              Hints{!isOptional && <span className={classes.requiredHeading}>*</span>}
              <span className={classes.optionalText}>  (Optional)</span>
              {this.checkForFeedback() && (
                <Grid className="feedbackBlock">
                   <AddFeedback 
                   author={this.props.authorType}
                   replyFeedback={this.props.replyFeedback} closeFeedback={this.props.closeFeedback} resolveFeedback={this.props.resolveFeedback} clickedfeedbackData={this.props.clickedfeedbackData} addNewFeedback={this.props.addNewFeedback} />
              </Grid>)}
                {
                  activeValidationFeedbackSection === SECTIONS.HINTS && (
                    <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                  )
                }
              </span>    
              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Hints"
                imageURL="/assets/svg/infoIcon/hints.svg"
                dialogPara="Add the hints for the questions (if any) that the students can view while attempting it"
                details="Click to know more"
                toolTipDirection="top" />    
            </Typography>
          )
        }
      >
        <div>
          <MyPATMathField
            gridSize={12}
            variant='textarea'
            editorProps={{
              externalToolbarId: 'box',
              name: 'questionHints',
              value: questionHints,
              editorId: inputId,
              handleChange: handleFormChange,
              setInstance: this.setMathInstance,
              placeholder
            }}
          />
        </div>
      </MyPATExpansionPanel>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(Hints);